import { EditorContent, useEditor } from '@tiptap/react';
import React, { useMemo, useEffect } from 'react';

import clsx from 'clsx';

import Stack from '@gogame/ui/Stack';
import { makeStyles } from '@gogame/ui/styles';

import { getCallBacks } from '../helpers';
import Toolbar from './Toolbar';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  editor: {
    '& .ProseMirror': {
      padding: '0 10px',
      wordBreak: 'break-word',
    },
    '& p': {
      margin: '10px 0',
    },
    '& .mention': {
      color: `${theme.palette.primary.main}`,
      cursor: 'pointer',
    },
    '& .tiptap p.is-editor-empty:first-child::before': {
      color: `${theme.palette.text.disabled}`,
      content: 'attr(data-placeholder)',
      float: 'left',
      height: '0',
      pointerEvents: 'none',
    },
    width: '100%',
  },
}));
export const RichTextInput = React.forwardRef(
  (
    {
      onChange,
      value,
      label,
      autofocus,
      extensions,
      error,
      className,
      onBlur,
      onFocus,
      onUpdateEditorCallback,
      showToolbar,
      placeholder,
    },
    ref
  ) => {
    const classes = useStyles();
    const editor = useEditor({
      autofocus: autofocus,
      extensions: extensions,
      content: value,
      onUpdate: ({ editor }) => {
        return onUpdateEditorCallback({ onChange, editor });
      },
    });
    useEffect(() => {
      if (!editor || editor.isFocused) {
        return;
      }
      let html = editor.getHTML();
      if (html !== value) {
        editor.commands.setContent(value);
      }
    }, [editor, value]);

    useMemo(() => {
      if (editor) {
        if (editor.isFocused) {
          onFocus();
        } else {
          onBlur();
        }
      }
    }, [editor?.isFocused]);

    if (!editor) {
      return null;
    }

    return (
      <Stack direction={'column'} className={classes.root}>
        {showToolbar && (
          <Toolbar editor={editor} callbacks={{ ...getCallBacks(editor) }} />
        )}
        <EditorContent
          editor={editor}
          data-cy={'rich-text-input'}
          className={clsx(className, classes.editor)}
        />
      </Stack>
    );
  }
);
